export default {
  auth: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/layouts/default.vue").then(m => m.default || m)
}